export const NumberRegExps = {
  NumbersDots: /[^.\d]/g,
  NumbersDotsHyphen: /[^-.\d]/g,
  NumbersOnlyOneDot: /^(\d*\.?)|(\d*)\.?/g,
  NumberSplitBy: /\B(?=(\d{3})+(?!\d))/g,
}
